import React, { useEffect, useState } from 'react';
import Auxiliary from 'hoc/Auxiliary';
import Paper from '@material-ui/core/Paper';
import {
    Checkbox,
    FilledInput,
    Grid,
    MenuItem,
    MuiThemeProvider,
    TextField
} from '@material-ui/core';
import classes from 'components/FuelVendor/FuelVendorDetails/FuelVendorDetail.module.css';
import cs from 'classnames';
import Styles from '../FuelVendorDetail.module.css';
import * as Constants from 'constants/Constants';
import { isEmptyObject, isNotBlank } from 'components/Common/Utils/StringUtils';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FILLED_INPUT_SELECT_THEME, INTEGRATION_TYPES_THEME } from '../FuelVendorDetailMuiTheme';
import { connect } from 'react-redux';
import * as actions from 'components/FuelVendor/store/actions';
import { withRouter } from 'react-router-dom';
import validateFuelFields from '../Validation/FuelValidation';
import InputLabel from '@material-ui/core/InputLabel/InputLabel';
import Select from '@material-ui/core/Select/Select';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

const BatchType = (props) => {
    const {
        fuelVendorAccount,
        updateFuelAccount,
        toggleEditFuelDetails,
        updatedFuelVendorAccount,
        discardChanges,
        toggleSaveButton,
        toggleEditDetails
    } = props;

    const initialBatchObject = {
        auto_delete: false,
        connection_type: '',
        file_mask: '',
        port: '',
        remote_folder: '',
        url: '',
        use_passive: false
    };

    const [batchInfo, setBatchInfo] = useState(
        isEmptyObject(fuelVendorAccount.batch) ? initialBatchObject : updatedFuelVendorAccount.batch
    );

    const defErrorConfig = {
        invalid: false,
        message: ''
    };
    const [field, setFieldValidation] = useState({
        connection_type: defErrorConfig,
        file_mask: defErrorConfig,
        port: defErrorConfig,
        remote_folder: defErrorConfig,
        url: defErrorConfig
    });

    const MenuProps = {
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
        },
        getContentAnchorEl: null
    };

    useEffect(() => {
        updateFuelAccount({ ...updatedFuelVendorAccount, batch: batchInfo });
    }, [batchInfo]);

    useEffect(() => {
        if (discardChanges) {
            setBatchInfo(fuelVendorAccount.batch);
            if (isEmptyObject(fuelVendorAccount)) {
                setBatchInfo(initialBatchObject);
            }
            setFieldValidation({
                connection_type: defErrorConfig,
                file_mask: defErrorConfig,
                port: defErrorConfig,
                remote_folder: defErrorConfig,
                url: defErrorConfig
            });
        }
    }, [discardChanges]);

    const handleChange = (event) => {
        let { name, value } = event.target;
        if (name === 'auto_delete' || name === 'use_passive') {
            value = event.target.checked;
        } else {
            validateFields(event);
        }
        setBatchInfo({ ...batchInfo, [name]: value });
        toggleEditDetails(true);
    };

    const validateFields = (event) => {
        const { name } = event.target;
        const result = validateFuelFields(event);
        setFieldValidation({ ...field, [name]: result });
        if (result.invalid) {
            toggleSaveButton(true);
        } else {
            toggleSaveButton(false);
        }
    };

    const handleClose = (event) => {
        const { value } = event.target;
        let event1 = { target: {} };
        event1.target.name = 'connection_type';
        event1.target.value = value ? value : '';
        if (!batchInfo.connection_type) {
            validateFields(event1);
        }
    };

    return (
        <Auxiliary>
            <MuiThemeProvider theme={INTEGRATION_TYPES_THEME}>
                <Paper elevation={0} className={Styles.defaultPaperHeight}>
                    <Grid container justify={'space-between'} direction={'row'}>
                        <Grid item xs={12}>
                            <label className={classes.typeHeaderText} id={'FTP_Properties'}>
                                FTP Properties
                            </label>
                        </Grid>
                        <Grid item xs={12} className={classes.lineSpace}>
                            <hr className={classes.line} />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justify={'space-between'} direction={'row'}>
                                <Grid item xs={4}>
                                    <MuiThemeProvider theme={FILLED_INPUT_SELECT_THEME}>
                                        <FormControl>
                                            <InputLabel
                                                htmlFor="Connection-Type-label"
                                                shrink={
                                                    isNotBlank(batchInfo.connection_type)
                                                        ? batchInfo.connection_type.length > 0
                                                        : false
                                                }
                                                error={field.connection_type.invalid}
                                            >
                                                Connection Type*
                                            </InputLabel>
                                            <Select
                                                labelId="Connection-Type"
                                                id="connection_type"
                                                name="connection_type"
                                                required
                                                fullWidth
                                                variant={'standard'}
                                                input={
                                                    <FilledInput
                                                        name="Select-an-Event-Type"
                                                        id="Select-an-Event-Type-label"
                                                    />
                                                }
                                                value={batchInfo.connection_type}
                                                onChange={(event) => handleChange(event)}
                                                onClose={(event) => handleClose(event)}
                                                renderValue={(selected) => selected}
                                                label={'Connection Type'}
                                                MenuProps={MenuProps}
                                                disabled={!toggleEditFuelDetails}
                                            >
                                                {Constants.BATCH_CONNECTION_TYPES.map((option) => (
                                                    <MenuItem key={option} value={option}>
                                                        {option}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            <FormHelperText>
                                                {field.connection_type.message}
                                            </FormHelperText>
                                        </FormControl>
                                    </MuiThemeProvider>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        className={cs(classes.textField, classes.fieldWidth)}
                                        required
                                        label={'URL'}
                                        name={'url'}
                                        value={batchInfo.url}
                                        disabled={!toggleEditFuelDetails}
                                        onChange={(event) => handleChange(event)}
                                        onBlur={(event) => validateFields(event)}
                                        error={field.url.invalid}
                                        helperText={field.url.message}
                                        id={'url'}
                                        fullWidth
                                        variant="filled"
                                        margin="dense"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justify={'space-between'} direction={'row'}>
                                <Grid item xs={12}>
                                    <TextField
                                        className={cs(classes.textField, classes.fieldWidth)}
                                        required
                                        label={'Remote Folder'}
                                        name={'remote_folder'}
                                        value={batchInfo.remote_folder}
                                        disabled={!toggleEditFuelDetails}
                                        onChange={(event) => handleChange(event)}
                                        onBlur={(event) => validateFields(event)}
                                        error={field.remote_folder.invalid}
                                        helperText={field.remote_folder.message}
                                        id={'remote_folder'}
                                        fullWidth
                                        variant="filled"
                                        margin="dense"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justify={'space-between'} direction={'row'}>
                                <Grid item xs={6}>
                                    <TextField
                                        className={cs(classes.textField, classes.fieldWidth)}
                                        required
                                        label={'File Mask'}
                                        name={'file_mask'}
                                        value={
                                            isEmptyObject(batchInfo.file_mask)
                                                ? ''
                                                : batchInfo.file_mask
                                        }
                                        disabled={!toggleEditFuelDetails}
                                        onChange={(event) => handleChange(event)}
                                        onBlur={(event) => validateFields(event)}
                                        error={field.file_mask.invalid}
                                        helperText={field.file_mask.message}
                                        id={'file_mask'}
                                        fullWidth
                                        variant="filled"
                                        margin="dense"
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        className={cs(classes.textField, classes.fieldWidth)}
                                        required
                                        label={'Port'}
                                        name={'port'}
                                        value={isEmptyObject(batchInfo.port) ? '' : batchInfo.port}
                                        disabled={!toggleEditFuelDetails}
                                        onChange={(event) => handleChange(event)}
                                        onBlur={(event) => validateFields(event)}
                                        error={field.port.invalid}
                                        helperText={field.port.message}
                                        id={'port'}
                                        fullWidth
                                        variant="filled"
                                        margin="dense"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event) => handleChange(event)}
                                        disabled={!toggleEditFuelDetails}
                                        checked={batchInfo.auto_delete}
                                        name="auto_delete"
                                    />
                                }
                                label="Auto Delete"
                                id={'auto_delete'}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={(event) => handleChange(event)}
                                        disabled={!toggleEditFuelDetails}
                                        checked={batchInfo.use_passive}
                                        name="use_passive"
                                    />
                                }
                                label="Use Passive"
                                id={'use_passive'}
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </MuiThemeProvider>
        </Auxiliary>
    );
};

const mapStateToProps = (state) => {
    return {
        fuelVendorAccount: state.fuelVendor.fuelVendorAccount,
        updatedFuelVendorAccount: state.fuelVendor.updatedFuelVendorAccount,
        discardChanges: state.fuelVendor.discardChanges
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateFuelAccount: (account) => dispatch(actions.updateFuelAccount(account)),
        toggleSaveButton: (flag) => dispatch(actions.toggleSaveButton(flag)),
        toggleEditDetails: (flag) => dispatch(actions.toggleEditDetails(flag))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BatchType));
